// Dev-only logging helper. No-ops in production builds to avoid leaking debug info.
const isDev = process.env.NODE_ENV === "development";

export const logError = (...args) => {
  if (isDev) console.error(...args);
};
